/**
 * Return gtm classes for bookmark button
 * @param  {Bool} is poi already marked
 * @return {String}        Class names
 */
export function bookmarkButtonGtmClasses(marked) {
    var gtmClass = "js-gtm-bookmark-button";
    return gtmClass + " " + (gtmClass + (marked ? "-remove" : "-add"));
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/gtm.ts
// module id = Meto
// module chunks = 2